// Default export.
import * as CanvasCapture from './CanvasCapture';
export default CanvasCapture;

// Named export.
export { CanvasCapture };